import { render, staticRenderFns } from "./SignInForm.vue?vue&type=template&id=a6a70b02&scoped=true&"
import script from "./SignInForm.vue?vue&type=script&lang=js&"
export * from "./SignInForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a70b02",
  null
  
)

export default component.exports